import { Injectable } from '@angular/core'

// For older IE and special Safari's privacy settings it throws unexpected errors
@Injectable({
  providedIn: 'root',
})
export class SessionStorage implements Storage {
  private readonly storageMap = new Map<string, any>()

  get length(): number {
    return this.storageMap.size
  }

  getItem(name: string): string | null {
    return this.storageMap.get(name) || null
  }

  setItem(name: string, value: any): void {
    this.storageMap.set(name, value.toString())
  }

  clear(): void {
    this.storageMap.clear()
  }

  key(index: number): string | null {
    const key = (this.storageMap.keys() as any)[index]
    return key && this.getItem(key)
  }

  removeItem(key: string): void {
    this.storageMap.delete(key)
  }
}
